import { Controller } from '@hotwired/stimulus'
import Highcharts from 'highcharts'
import HcExporting from 'highcharts/modules/exporting'
import HcExportData from 'highcharts/modules/export-data'

HcExporting(Highcharts)
HcExportData(Highcharts)

export default class extends Controller {
  static targets = [ 'chart', 'loader' ]
  static values  = { url: String, stacking: Boolean }
  static classes = [ 'hidden' ]

  static defaultOptions = {
    exporting: { buttons: { contextButton: { menuItems: ['downloadXLS', 'downloadCSV'] } } },
    navigation: { menuItemHoverStyle: { background: 'var(--color-brand-400)', color: '#ffffff' } },
  }

  connect() {
    this.load()
  }

  load() {
    this.loaderTarget.classList.remove(this.hiddenClass)
    fetch(new URL(this.urlValue), { headers: { 'X-Requested-With': 'XMLHttpRequest', accept: 'application/json' } })
      .then(response => response.json())
      .then(data => {
        this.chart = Highcharts.chart(this.chartTarget, { ...this.constructor.defaultOptions, ...data })
        this.loaderTarget.classList.add(this.hiddenClass)
      })
  }
}
